<ng-container [ngSwitch]="phase">
  <div *ngSwitchCase="'loading'">
    <div style="margin-top: 40px" fxLayoutAlign="center center" fxLayout="column" fxLayoutGap="12px">
      <mat-spinner diameter="32"></mat-spinner>
      <span>Checking your account...</span>
    </div>
  </div>

  <div *ngSwitchCase="'error'">
    <div style="margin-top: 40px" fxLayoutAlign="center center" fxLayout="column" fxLayoutGap="12px">
      <span>{{ error }}</span>
    </div>
  </div>

  <div *ngSwitchCase="'matching'">
    <div style="margin-top: 40px" fxLayoutAlign="center center" fxLayout="column" fxLayoutGap="12px">
      <span>Matching locks...</span>
    </div>
  </div>

  <ng-container *ngSwitchCase="'success'">
    <div *ngIf="deviceType === 'lock'" fxFlexFill fxLayoutAlign="center center" fxLayout="column" fxLayoutGap="12px">
      <div class="max-w-2xl w-full">
        <h2>🎉 Smart Device Setup Successful</h2>
        <h3>What happens now</h3>

        <ul>
          <li>Two backup codes will be created on your locks for each property it is matched with.</li>
          <li>
            If a code is unable to be set on a lock, a backup code will be sent to the guest, and the code will be
            deleted after checkout.
          </li>
          <li>Codes for future reservations will be automatically created.</li>
          <li>We will attempt to match all existing codes with existing reservations.</li>
          <li>All codes are deleted from the device after the end time.</li>
          <li>All codes and devices can be managed in your device dashboard.</li>
        </ul>

        <div fxLayoutAlign="end center">
          <a [routerLink]="['/devices']"><sbnb-button>Continue</sbnb-button></a>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
